module.exports = __webpack_public_path__ + "img/C21338_920C24_E71C54_F34A7D-256px.1af1ac6a.png";